<header class="app-header d-flex align-items-center justify-content-between px-3 px-md-4">
  <div class="left">
    <h4 class="greeting mb-1 mt-3">{{ greeting }} @if (sessionData) {
      <span>{{ sessionData.user.firstName }}</span>
      }@if (!sessionData) {
      <span>Admin</span>
      }!
    </h4>
    <div class="breadcrumb text-muted">
      <span>Admin / </span><strong>{{ pageTitle }}</strong>
    </div>
  </div>

  <div class="right d-flex align-items-center gap-3">
    <button class="icon-btn position-relative" aria-label="Notifications" (click)="goToNotifications()">
      <i class="pi pi-bell" style="font-size: 1.4rem; color: #495057;"></i>
      @if (unreadCount > 0) {
        <span class="position-absolute badge rounded-pill bg-danger" style="top: 2px; right: 2px; font-size: 0.6rem; padding: 0.25em 0.45em; border: 2px solid #fff;">
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>
      }
    </button>
    @if (!sessionData) {
    <div class="org-name text-muted d-none d-sm-block">Admin</div>
    }
    @if (sessionData) {
    <div class="org-name text-muted d-none d-sm-block">{{ sessionData.user.firstName }}</div>
    }
    <!-- Dummy avatar image -->
    <div class="avatar-menu">
      <img [src]="profilePhotoUrl ?? 'assets/images/user.png'" alt="User Avatar" class="avatar cursor-pointer"
        (click)="menu.toggle($event)" />

      <p-menu #menu [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
    </div>
  </div>
</header>